import type { FileAppData } from '../types';

type FileUpload = {
  files: Array<FileAppData>;
};

export class UploadImageService {
  _fileappURL: string;

  constructor($url: string) {
    this._fileappURL = $url;
  }

  isRequestValid(xhr: XMLHttpRequest) {
    return xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300;
  }

  uploadFileToUrl(file: File, onProgress: (progressPercent: number) => void): Promise<FileAppData> {
    return new Promise<FileAppData>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          onProgress(Math.round((event.loaded / event.total) * 100));
        }
      });

      xhr.onreadystatechange = () => {
        if (this.isRequestValid(xhr)) {
          try {
            const data = JSON.parse(xhr.response) as FileUpload;
            const file: FileAppData = data.files[0];
            resolve(file);
          } catch {
            reject(new Error('Invalid server response'));
          }
        } else if (xhr.readyState === 4 && xhr.status == 400) {
          reject(new Error('Invalid server response'));
        }
      };

      const formData = new FormData();
      formData.append('file', file);

      xhr.open('POST', this._fileappURL, true);
      xhr.send(formData);
    });
  }
}
